import { customerLocaleToLocalizationLanguage, type LocalizationLanguageCode } from 'noddi-util';
import { useLanguageContext } from '../contexts/useLanguageContext';

/** Maps the customer UI locale to the backend LanguageCode used for sales-item content. */
export const useLocalizationLanguage = (): LocalizationLanguageCode => {
  const { currentLanguage } = useLanguageContext();
  return customerLocaleToLocalizationLanguage(currentLanguage);
};
